import React from "react";
import { useImperativeHandle } from "react";

import { useTranslation } from "react-i18next";

const PlatePicker = ({ maxL, linkdoc, startvalue, onCustomEvent }, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(startvalue);
  const [maxH, setMaxH] = React.useState(maxL);
  const [doc, setDoc] = React.useState(linkdoc);

  const plateDatabase = [
    { label: "T-ALU 9-80x109.4x80", value: "1", minL: 89, doc: "ETA130757.pdf" },
    { label: "T-ALU 9-120x109.4x80", value: "2", minL: 120, doc: "ETA130757.pdf" },
    { label: "T-ALU 9-160x109.4x80", value: "3", minL: 160, doc: "ETA130757.pdf" },
    { label: "T-ALU 9-200x109.4x80", value: "4", minL: 200, doc: "ETA130757.pdf" },
    { label: "T-ALU 9-240x109.4x80", value: "5", minL: 240, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-120x109.4x80", value: "6", minL: 120, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-160x109.4x80", value: "7", minL: 160, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-200x109.4x80", value: "8", minL: 200, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-240x109.4x80", value: "9", minL: 240, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-280x109.4x80", value: "10", minL: 280, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-320x109.4x80", value: "11", minL: 320, doc: "ETA130757.pdf" },
    { label: "T-ALU 9 CF-360x109.4x80", value: "12", minL: 360, doc: "ETA130757.pdf" },
  ];

  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    sendDataToParent(value);
    setDoc(plateDatabase.find((e) => e.value === value).doc);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
    setMaxL: setMaxL,
  }));
  const getData = () => {
    return selectValue;
  };
  const getOptions = () => {
    var newList = [];
    for (const element of plateDatabase) {
      if (element.minL <= maxH) {
        newList.push(element);
      }
    }
    return newList;
  };
  const sendDataToParent = (value) => {
    onCustomEvent(value);
  }

  const setMaxL = (l) => {
    if (l) {
      setMaxH(l);
    }
  };

  return (
    <div className="form-col1_6">
      <label className="form-label" for="grid-Screw">
        {t("Plate")}
        <a href={doc} download={doc} target="_blank" rel="noreferrer">
            {" "}
            [Pdf]
          </a>
      </label>
      <select class="form-select" id="grid-Plate" name="grid-Plate" onChange={onChange} defaultValue={selectValue}>
        {getOptions().map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
};

export default React.forwardRef(PlatePicker);
